import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { customTheme } from "themes";
import { Toaster } from "react-hot-toast";
import CssBaseline from "@mui/material/CssBaseline";
import Routes from "routes";

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } },
});

function App() {
  // custom Theme
  const appTheme = customTheme();

  // toaster options
  const toasterOptions = {
    style: {
      fontWeight: 500,
    },
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appTheme}>
        <QueryClientProvider client={queryClient}>
          <CssBaseline />
          <Toaster toastOptions={toasterOptions} />
          <Routes />
        </QueryClientProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
